// extracted by mini-css-extract-plugin
export default {"btnBox":"management_btnBox__YrN-Y"};